var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1100,
    height: 285,
    viewBox: "0 0 1100 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_27_2303)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M514.97 139.234C627.662 136.586 777.324 129.217 842.436 146.326C907.768 163.492 763.335 179.887 743.342 199.24C724.307 217.667 808.629 240.373 732.163 253.073C641.177 268.184 484.091 273.154 366.992 261.747C254.835 250.821 240.437 225.227 224.62 203.631C212.636 187.269 235.599 171.759 291.931 159.265C345.839 147.309 426.016 141.325 514.97 139.234Z",
    fill: "#20D5FC",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_27_2303",
    x: -27.7502,
    y: -113.909,
    width: 1136.31,
    height: 631.19,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 124.64,
    result: "effect1_foregroundBlur_27_2303"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportBackground);
export default __webpack_public_path__ + "static/media/support-background.a49a247ada55d4a5855e997c2ed3504e.svg";
export { ForwardRef as ReactComponent };